<script>
import { onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useModalStore } from '@/stores/modal.js';
import { useAuthenticationStore } from '@/stores/authentication.js';
import { updateUser } from '@/lib/api/users';

export default {
  setup() {
    // Variables
    const isLoading = ref(true);
    const acceptedIncentive = ref(false);
    const canOfferIncentive = ref(true);

    // Stores
    const authStore = useAuthenticationStore();
    const modalStore = useModalStore();

    // I18n
    const { tm, t } = useI18n();

    onMounted(async () => {
      canOfferIncentive.value = !Boolean(authStore.currentUser.user.attributes.autowise_account_deletion_retention_deal_claimed_at)
    });

    const acceptIncentive = async () => {
      let current_time = new Date().toISOString()
      acceptedIncentive.value = true;
      authStore.currentUser.user.attributes.autowise_account_deletion_retention_deal_claimed_at = current_time

      const user = {
        autowise_account_deletion_retention_deal_claimed_at: current_time
      };

      try {
        const response = await updateUser(authStore.currentUser.authenticatable_id, user);
        if (response) {
          authStore.setUserCurrentUser(response.data);
          isLoading.value = false;
        }
      } catch (error) {
        console.error('error', error);
        isLoading.value = false;
      }
    }

    const backToAutowise = () => {
      modalStore.resetModal();
    }

    const rejectIncentiveAndDelete =  () => {
      authStore.deleteUserAccount();
    }

    return {
      tm,
      t,
      isLoading,
      acceptIncentive,
      rejectIncentiveAndDelete,
      acceptedIncentive,
      canOfferIncentive,
      backToAutowise
    }
  },
};
</script>

<template>
  <div class="justify-center items-center w-full p-4">
    <p v-if="!acceptedIncentive && canOfferIncentive" v-for="blurb in tm('modal.delete_account.account_closure_plea')" class="mb-2">
      {{ blurb }}
    </p>
    <p v-else-if="!canOfferIncentive && !acceptedIncentive" class="mb-2">
      {{ t('modal.delete_account.account_closure_statement') }}
    </p>
    <p v-else v-for="blurb in tm('modal.delete_account.post_incentive_gratitude')" class="mb-2">
      {{ blurb }}
    </p>

    <hr/>

    <div class="flex justify-end mt-4">
      <div v-if="canOfferIncentive">
        <div v-if="acceptedIncentive">
          <button @click="backToAutowise()" class="positive-button rounded-md font-semibold px-4 py-2 ml-5 hover:opacity-75 mx-4">{{ tm('modal.delete_account.back_button') }}</button>
        </div>
        <div v-else>
          <button @click="acceptIncentive()" class="positive-button rounded-md font-semibold px-4 py-2 ml-5 hover:opacity-75 mx-4">{{ tm('modal.delete_account.claim_incentive') }}</button>
          <button @click="rejectIncentiveAndDelete()" class="negative-button font-semibold inline-block justify-end hover:opacity-75">{{ tm('modal.delete_account.delete_my_account') }}</button>
        </div>
      </div>
      <div v-else>
        <button @click="backToAutowise()" class="positive-button rounded-md font-semibold px-4 py-2 ml-5 hover:opacity-75 mx-4">{{ tm('modal.delete_account.claim_incentive') }}</button>
        <button @click="rejectIncentiveAndDelete()" class="negative-button font-semibold inline-block justify-end hover:opacity-75">{{ tm('modal.delete_account.delete_my_account') }}</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/modal";
@import '@/assets/styles/components/modals/delete_account';
</style>
